/*
 * holy-ritual-statement.js · 2026-06-05
 *
 * Picks one of the rotating brand statements (read from data-statements
 * on the root) and writes it into [data-holy-rs-target] on page load.
 *
 * Pool is configured server-side via the snippet so Preston can change
 * statements by editing snippets/holy-ritual-statement.liquid alone.
 */

(function () {
  'use strict';

  function pickAndApply(root) {
    if (!root) return;
    var target = root.querySelector('[data-holy-rs-target]');
    if (!target) return;
    var raw = root.getAttribute('data-statements');
    if (!raw) return;
    var statements;
    try {
      statements = JSON.parse(raw);
    } catch (e) {
      return;
    }
    if (!Array.isArray(statements) || statements.length === 0) return;
    var idx = Math.floor(Math.random() * statements.length);
    target.textContent = statements[idx];
    target.setAttribute('data-active-index', String(idx));
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-holy-rs]');
    for (var i = 0; i < roots.length; i++) {
      pickAndApply(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    var roots = section.querySelectorAll('[data-holy-rs]');
    for (var i = 0; i < roots.length; i++) {
      pickAndApply(roots[i]);
    }
  });
})();
